<template>
    <div class="whatsapp-container">
      <button 
        class="whatsapp-button"
        @click="openWhatsApp"
      >
        <svg class="whatsapp-icon" viewBox="0 0 24 24" width="24" height="24">
          <path fill="currentColor" d="M12.04 2c-5.46 0-9.91 4.45-9.91 9.91c0 1.75.46 3.45 1.32 4.95L2.05 22l5.25-1.38c1.45.79 3.08 1.21 4.74 1.21c5.46 0 9.91-4.45 9.91-9.91c0-5.46-4.45-9.91-9.91-9.91m3.19 13.92c-.24.66-.59 1.12-1.17 1.12c-.61 0-.86-.31-2.06-.31c-1.17 0-1.5.28-2.06.31c-.56 0-.94-.46-1.17-1.12c-.23-.66-.92-3.59-.92-3.59s.69-.77.94-.77c.24 0 .33.02.47.11c.13.09.43.47.52.61c.09.13.13.28.23.28c.09 0 .14-.06.23-.28c.09-.21.33-.52.52-.8c.19-.28.28-.47.47-.47c.19 0 .33.09.42.33c.09.24.56 1.57.66 1.88c.09.31.14.33.24.33c.09 0 .19-.06.33-.31c.14-.24.56-1.07.7-1.43c.14-.37.07-.56-.04-.73c-.11-.17-.42-.28-.66-.28c-.19 0-.33.02-.47.09c-.14.07-.56.28-.66.33c-.09.05-.19.05-.28-.05c-.09-.09-.66-.82-.9-1.12c-.23-.28-.47-.31-.66-.31c-.19 0-.38.02-.52.11c-.14.09-.33.28-.33.28s-.38.42-.42.56c-.05.14-.05.33.05.52c.09.19 1.03 1.78 1.17 1.97c.14.19 2.01 3.24 2.43 3.67c.42.42.75.52 1.03.52c.28 0 .42-.02.61-.09c.19-.07.75-.33 1.12-.52c.37-.19.66-.28.75-.47c.09-.19.09-.37-.05-.56"/>
        </svg>
        <span class="button-text">Chat on WhatsApp</span>
      </button>
    </div>
  </template>
  
  <script>
  export default {
    name: 'WhatsAppButton',
    props: {
      phoneNumber: {
        type: String,
        default: '1234567890' // Replace with your number
      },
      message: {
        type: String,
        default: 'Hello! I have an enquiry about your services.'
      }
    },
    methods: {
      openWhatsApp() {
        const encodedMessage = encodeURIComponent(this.message);
        const url = `https://wa.me/${this.phoneNumber}?text=${encodedMessage}`;
        window.open(url, '_blank');
      }
    }
  }
  </script>
  
  <style scoped>
  .whatsapp-container {
    position: fixed;
    bottom: 20px;
    right: 20px;
    z-index: 1000;
  }
  
  .whatsapp-button {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    background-color: #25D366;
    color: white;
    border: none;
    border-radius: 50px;
    padding: 12px 24px;
    font-size: 16px;
    font-weight: 600;
    cursor: pointer;
    box-shadow: 0 4px 12px rgba(37, 211, 102, 0.3);
    transition: all 0.3s ease;
  }
  
  .whatsapp-button:hover {
    background-color: #128C7E;
    transform: translateY(-2px);
    box-shadow: 0 6px 16px rgba(37, 211, 102, 0.4);
  }
  
  .whatsapp-icon {
    width: 24px;
    height: 24px;
  }
  
  .button-text {
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  }
  </style>